module.exports = "/dist/fonts/Roboto-Bold.e07df86c.ttf";